<template>
  <layout>
    <home-hero />
    <home-deal-types />
    <how-it-works />
    <financing-benefits />
    <consulting-info />
  </layout>
</template>

<script>
import Layout from '@/modules/home/components/ui/layout'

import ConsultingInfo from './ConsultingInfo'
import FinancingBenefits from './FinancingBenefits'
import HomeDealTypes from './DealTypes'
import HomeHero from './Hero'
import HowItWorks from './HowItWorks'

export default {
  name: 'HomePage',
  components: {
    Layout,
    ConsultingInfo,
    FinancingBenefits,
    HomeDealTypes,
    HomeHero,
    HowItWorks,
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  h2, h3 {
    color: $textDarkMuted;
    &.light { color: #0E96A6; }
  }

  p {
    letter-spacing: 0.64px;
    color: $textDarkMuted;
  }

  v-main .default-btn {
    min-height: 50px;
    padding: 0 25px;
  }
}

</style>
